import { AnimatedPage } from '@components/animated'
import { Referrals } from '@features/settings/components/Referrals'
import { useTranslation } from 'react-i18next'

export function ReferralsPage() {
  const { t } = useTranslation('settings')

  return (
    <AnimatedPage>
      <div className="app-chrome space-y-6">
        <header className="flex items-center gap-3">
          <span
            aria-hidden
            className="h-9 w-1.5 shrink-0 rounded-full bg-gradient-to-b from-primary to-peach"
          />
          <div>
            <h1 className="m-0 font-display text-2xl font-bold tracking-tight text-ink lg:text-3xl">
              {t('referrals.title')}
            </h1>
            <p className="mt-0.5 text-muted-foreground">
              {t('referrals.pageSubtitle')}
            </p>
          </div>
        </header>

        <Referrals bare />
      </div>
    </AnimatedPage>
  )
}
